// dashbaord
import Default from '../Components/Dashboard/Default';
import Ecommerce from '../Components/Dashboard/Ecommerce';

//Page layout
import AccountAdd from '../Components/Configuration/Account/AccountAdd';
import Account from '../Components/Configuration/Account/Account';

//forms
import IndustryAdd from '../Components/Forms/FormControl/IndustryAdd';

import UsersProfileContain from '../Components/App/Users/UsersProfile';
import Invoice from '../Components/App/Ecommerce/Invoice';

//sample page
import AccountEdit from '../Components/Configuration/Account/AccountEdit';
import RoleContainer from '../Components/Masterrecords/Role/Role';
import RoleAdd from '../Components/Masterrecords/Role/RoleAdd';
import AddonsContainer from '../Components/Masterrecords/Addon/Addons';
import AddonsAdd from '../Components/Masterrecords/Addon/AddAddons';
import AddonsEdit from '../Components/Masterrecords/Addon/AddAddonsEdit';
import UserAddress from '../Components/Masterrecords/User/UserAddress';
import UserAddressAdd from '../Components/Masterrecords/User/UserAddressAdd';
import PaymentAdd from '../Components/App/Ecommerce/Invoice/AddPayments';
import CompanyList from '../Components/Companies/companies/CompanyList';
import CompanyEdit from '../Components/Companies/companies/CompanyEdit';
import CompanyAdd from '../Components/Companies/companies/CompanyAdd';
import Temperoraylist from '../Components/Companies/temporary/TempList';
import InvoiceAdd from '../Components/Billing/invoice/InvoiceAdd';
import Invoicelist from '../Components/Billing/invoice/Invoice';
import Subscription from '../Components/Billing/subscription/Subscription';
import SubscriptionAdd from '../Components/Billing/subscription/SubscriptionAdd';
import IndustryEdit from '../Components/Configuration/Industries/IndustryEdit';
import Industryy from '../Components/Configuration/Industries/Industryy';
import TaxGroupAdd from '../Components/Configuration/Tax/TaxGroupAdd';
import TaxGroupEdit from '../Components/Configuration/Tax/TaxGroupEdit';
import TaxAddForm from '../Components/Configuration/Tax/TaxAdd';
import TaxEdit from '../Components/Configuration/Tax/TaxEdit';
import Tax from '../Components/Configuration/Tax/Tax';
import Packages from '../Components/Configuration/Packages/Packages';
import PackagesAdd from '../Components/Configuration/Packages/PackagesAdd';
import PackagesEdit from '../Components/Configuration/Packages/PackagesEdit';
import CouponList from '../Components/Configuration/Coupon/CouponTable';
import CouponForm from '../Components/Configuration/Coupon/CouponForm';
import CouponEdit from '../Components/Configuration/Coupon/CouponEdit';
import Zone from '../Components/Configuration/Zones/Zone';
import ZoneAdd from '../Components/Configuration/Zones/ZoneAdd';
import ZoneEdit from '../Components/Configuration/Zones/ZoneEdit';
import PaymentForm from '../Components/Configuration/PaymentMethod/PaymentForm';
import PaymentEdit from '../Components/Configuration/PaymentMethod/PaymentEdit';
import RoleEdit from '../Components/Masterrecords/Role/RoleEdit';
import SubscriptionEdit from '../Components/Billing/subscription/SubscriptionEdit';
import PaymentMethodList from '../Components/Configuration/PaymentMethod/PaymentList';
import Paymentlist from '../Components/Billing/Payment/Payment';
import ThermalPrint from '../Components/Billing/ThermalPrint/ThermalPrint-demo';
import TrialTable from '../Components/Companies/trialExpired/TrialTable';
import PrintComponent from '../Components/App/Ecommerce/Invoice/Print';
import FormDateRangepickerContain from '../Components/Forms/FormWidget/FormDateRangePicker';
import ChannelList from '../Components/Configuration/Channel/ChannelList';
import AddEditChannel from '../Components/Configuration/Channel/AddEditChannel';
import NotificationList from '../Components/Configuration/Notification/NotificationList';
import AddEditNotificationSettings from '../Components/Configuration/Notification/AddEditNotificationSettings';
import CompanyProfileContain from '../Components/Companies/CompanyProfile';
import NewCompany from '../Components/Companies/companies/NewCompany';
import RenewSub from '../Components/Billing/invoice/ThermalPrint-demo';
import Chart from '../Components/Widgets/Chart';
import ExpiredSubscriptions from '../Components/Reports/ExpiredSubscriptions';
import MonthlyRevenue from '../Components/Reports/MonthlyRevenue';
import PaymentDueSubscriptionTable from '../Components/Companies/paymentDueSubscription/PaymentDueSubscriptionTable';
import Package from '../Components/Reports/Package ';
import PendingPaymentReport from '../Components/Reports/PendingPaymentReport';
import CouponUsage from '../Components/Reports/CouponUsage';
import NotificationCreditUsage from '../Components/Reports/NotificationCreditUsage';
import NotificationCredit from '../Components/Reports/NotificationCredit';
import CompanyCreatedList from '../Components/Companies/CompanyCreatedList.jsx/CompanyCreatedList';
import MonthlyRevenueByIndustry from '../Components/Reports/MonthlyRevenueByIndustry';
import MonthlyRevenueByCompany from '../Components/Reports/MonthlyRevenueByCompany';
import MonthlyRevenueByPlan from '../Components/Reports/MonthlyRevenueByPlan';
import UsersTable from '../Components/Companies/Users/UsersTable';
import UsersList from '../Components/Companies/Users/UsersList';
import StaffContainer from '../Components/Masterrecords/Staff/Staff';
import AddStaffForm from '../Components/Masterrecords/Staff/StaffAdd';
import EditStaffForm from '../Components/Masterrecords/Staff/StaffEdit';
import ExpiredSubscriptionList from '../Components/Companies/ExpiredSubscription/ExpiredSubscriptionList';
import EnquiriesList from '../Components/LeadManager/Enquiries/EnquiriesList';
import AddEnquiry from '../Components/LeadManager/Enquiries/AddEnquiy';
import EditEnquiry from '../Components/LeadManager/Enquiries/EditEnquiry';
import EnquiryDetails from '../Components/LeadManager/Enquiries/EnquiryDetails';
import LeadList from '../Components/LeadManager/Leads/LeadsList';
import LeadsDetails from '../Components/LeadManager/Leads/LeadsDetails';
import FollowUps from '../Components/LeadManager/Follow-up/FollowUps';
import AddFollowUp from '../Components/LeadManager/Follow-up/AddFollowUp';
import OverdueFollowUp from '../Components/LeadManager/overDueFollowUps/OverdueFollowUp';

export const routes = [
        //dashboard
        { path: `${process.env.PUBLIC_URL}/dashboard/default/`, Component: <Default /> },
        { path: `${process.env.PUBLIC_URL}/dashboard/ecommerce/`, Component: <Ecommerce /> },

        // Profile
        { path: `${process.env.PUBLIC_URL}/app/users/userProfile`, Component: <UsersProfileContain /> },
        
        //Companies
        { path: `${process.env.PUBLIC_URL}/subscriptions/active-sub`, Component: <CompanyList /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-edit`, Component: <CompanyEdit /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-add`, Component: <CompanyAdd /> },
        {path: `${process.env.PUBLIC_URL}/subscriptions/companyProfile`, Component: <CompanyProfileContain />},
        { path:`${process.env.PUBLIC_URL}/subscriptions/create-company`,Component:<NewCompany/>},
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile`, Component: <UsersProfileContain /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile/invoice`, Component: <Invoice /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile/invoice/payment-add`, Component: <PaymentAdd /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/temp-sub`, Component: <Temperoraylist /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/expiredSubscription`, Component: <ExpiredSubscriptionList /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/company-created-users`, Component: <CompanyCreatedList /> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/trial-expired`, Component: < TrialTable/> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/users`, Component: < UsersList/> },
        { path: `${process.env.PUBLIC_URL}/subscriptions/paymentDueSubscription`, Component: < PaymentDueSubscriptionTable/> },

        //Lear Manager
        { path: `${process.env.PUBLIC_URL}/lead-manage/enquiry`, Component: < EnquiriesList/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/addEnquiry`, Component: < AddEnquiry/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/editEnquiry`, Component: < EditEnquiry/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/enquiry-details`, Component: < EnquiryDetails/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/leads`, Component: < LeadList/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/leads-details`, Component: < LeadsDetails/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/follow-ups`, Component: < FollowUps/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/leads-details`, Component: < AddFollowUp/> },
        { path: `${process.env.PUBLIC_URL}/lead-manage/overdue-follow-ups`, Component: < OverdueFollowUp/> },




        //Billing
        { path: `${process.env.PUBLIC_URL}/billing/invoice-list`, Component: <Invoicelist /> },
        { path: `${process.env.PUBLIC_URL}/billing/invoice-add`, Component: <InvoiceAdd /> },
        { path: `${process.env.PUBLIC_URL}/billing/payment-list`, Component: <Paymentlist /> },
        { path: `${process.env.PUBLIC_URL}/billing/subscription`, Component: <Subscription /> },
        { path: `${process.env.PUBLIC_URL}/billing/subscription-add`, Component: <SubscriptionAdd /> },
        { path: `${process.env.PUBLIC_URL}/billing/subscription-edit`, Component: <SubscriptionEdit /> },
        { path: `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice`, Component: <PrintComponent /> },
        { path: `${process.env.PUBLIC_URL}/billing/thermal-print`, Component: <RenewSub /> },
        //Configuration
        { path: `${process.env.PUBLIC_URL}/configuration/industry-list`, Component: <Industryy /> },
        { path: `${process.env.PUBLIC_URL}/configuration/industry-add`, Component: <IndustryAdd /> },
        { path: `${process.env.PUBLIC_URL}/configuration/industry-edit`, Component: <IndustryEdit /> },
        
        { path: `${process.env.PUBLIC_URL}/configuration/tax-list`, Component: <Tax /> },
        { path: `${process.env.PUBLIC_URL}/configuration/tax-group-add`, Component: <TaxGroupAdd /> },
        { path: `${process.env.PUBLIC_URL}/configuration/tax-group-edit`, Component: <TaxGroupEdit /> },
        { path: `${process.env.PUBLIC_URL}/configuration/tax-add`, Component: <TaxAddForm /> },
        { path: `${process.env.PUBLIC_URL}/configuration/tax-edit`, Component: <TaxEdit /> },
        { path: `${process.env.PUBLIC_URL}/configuration/zone-list`, Component: <Zone /> },
        { path: `${process.env.PUBLIC_URL}/configuration/zone-add`, Component: <ZoneAdd /> },
        { path: `${process.env.PUBLIC_URL}/configuration/zone-edit`, Component: <ZoneEdit /> },

        { path: `${process.env.PUBLIC_URL}/configuration/account`, Component: <Account /> },
        { path: `${process.env.PUBLIC_URL}/configuration/account-add`, Component: <AccountAdd /> },
        { path: `${process.env.PUBLIC_URL}/configuration/account-edit`, Component: <AccountEdit /> },

        { path: `${process.env.PUBLIC_URL}/configuration/packages`, Component: <Packages /> },
        { path: `${process.env.PUBLIC_URL}/configuration/packages-add`, Component: <PackagesAdd /> },
        { path: `${process.env.PUBLIC_URL}/configuration/packages-edit`, Component: <PackagesEdit /> },

        { path: `${process.env.PUBLIC_URL}/configuration/coupon`, Component: <CouponList/> },
        { path: `${process.env.PUBLIC_URL}/configuration/coupon-add`, Component: <CouponForm/> },
        { path: `${process.env.PUBLIC_URL}/configuration/coupon-edit`, Component: <CouponEdit/> },
        
        { path: `${process.env.PUBLIC_URL}/configuration/payment-method`, Component: <PaymentMethodList/> },
        { path: `${process.env.PUBLIC_URL}/configuration/payment-method-add`, Component: <PaymentForm/> },
        { path: `${process.env.PUBLIC_URL}/configuration/payment-method-edit`, Component: <PaymentEdit/> },
        
        // Report
        { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByIndustry`, Component: <MonthlyRevenueByIndustry/> },
        { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByCompany`, Component: <MonthlyRevenueByCompany/> },
        { path: `${process.env.PUBLIC_URL}/reports/ExpiredSubscriptions`, Component: <ExpiredSubscriptions/> },
        { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenueByPlan`, Component: <MonthlyRevenueByPlan/> },
        { path: `${process.env.PUBLIC_URL}/reports/MonthlyRevenue`, Component: <MonthlyRevenue/> },
        { path: `${process.env.PUBLIC_URL}/reports/Package`, Component: <Package/> },
        { path: `${process.env.PUBLIC_URL}/reports/NotifiactionCredit`, Component: <NotificationCredit/> },
        { path: `${process.env.PUBLIC_URL}/reports/NotifiactionCreditUsage`, Component: <NotificationCreditUsage/> },
        { path: `${process.env.PUBLIC_URL}/reports/PendingPayment`, Component: <PendingPaymentReport/> },
        { path: `${process.env.PUBLIC_URL}/reports/CouponUsage`, Component: <CouponUsage/> },
        //master records
        { path: `${process.env.PUBLIC_URL}/master-records/role`, Component: <RoleContainer /> },
        { path: `${process.env.PUBLIC_URL}/master-records/role-add`, Component: <RoleAdd /> },
        { path: `${process.env.PUBLIC_URL}/master-records/role-edit`, Component: <RoleEdit /> },

        { path: `${process.env.PUBLIC_URL}/master-records/Staff`, Component: <StaffContainer /> },
        { path: `${process.env.PUBLIC_URL}/master-records/staff-add`, Component: <AddStaffForm /> },
        { path: `${process.env.PUBLIC_URL}/master-records/staff-edit`, Component: <EditStaffForm /> },

        { path: `${process.env.PUBLIC_URL}/master-records/addons`, Component: <AddonsContainer /> },
        { path: `${process.env.PUBLIC_URL}/master-records/addons-add`, Component: <AddonsAdd /> },
        { path: `${process.env.PUBLIC_URL}/master-records/addons-edit`, Component: <AddonsEdit /> },

        { path: `${process.env.PUBLIC_URL}/master-records/user-address`, Component: <UserAddress /> },
        { path: `${process.env.PUBLIC_URL}/master-records/user-address-add`, Component: <UserAddressAdd /> },
        { path: `${process.env.PUBLIC_URL}/form-widget/rangepicker`, Component: <FormDateRangepickerContain /> },
        { path: `${process.env.PUBLIC_URL}/widgets/chart/`, Component: <Chart /> },

        //thermal-print
        { path: `${process.env.PUBLIC_URL}/companies/company-list/invoice/thermal-print`, Component: <ThermalPrint /> },
        
        //notification-channel
        { path: `${process.env.PUBLIC_URL}/configuration/notification-channel`, Component: <ChannelList /> },
        { path: `${process.env.PUBLIC_URL}/configuration/add-channel`, Component: <AddEditChannel /> },
        { path: `${process.env.PUBLIC_URL}/configuration/edit-channel`, Component: <AddEditChannel /> },
        
        //notification settings
        { path: `${process.env.PUBLIC_URL}/configuration/notification-settings`, Component: <NotificationList /> },
        { path: `${process.env.PUBLIC_URL}/configuration/add-notification-settings`, Component: <AddEditNotificationSettings /> },
        { path: `${process.env.PUBLIC_URL}/configuration/edit-notification-settings`, Component: <AddEditNotificationSettings /> },
];
